// extracted by mini-css-extract-plugin
export default {"icon":"Loading_icon__kmiOX"};